/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: None = 0, GoogleCalendar = 1, MicrosoftOutlook = 2, AppleCalendar = 3
 */
export enum Routemize_Entities_Calendar_External_ExternalCalendarType {
    NONE = 'None',
    GOOGLE_CALENDAR = 'GoogleCalendar',
    MICROSOFT_OUTLOOK = 'MicrosoftOutlook',
    APPLE_CALENDAR = 'AppleCalendar',
}
